
import { Component, Vue } from 'vue-property-decorator'
import { getInviteRewardLogPage, IInviteRewardLog } from '@/api/inviteReward'
import UserNameRemark from '@/components/UserNameRemark/index.vue'

@Component({ name: 'InviteRewardLog', components: { UserNameRemark } })
export default class extends Vue {
  private loading = false
  private list: IInviteRewardLog[] = []
  private total = 0

  private query = {
    pageNum: 1,
    pageSize: 10,
    inviterPhone: '',
    inviteePhone: '',
    status: null as number | null
  }

  mounted() {
    this.loadList()
  }

  private async loadList() {
    this.loading = true
    try {
      const params: any = {
        pageNum: this.query.pageNum,
        pageSize: this.query.pageSize
      }
      if (this.query.inviterPhone) params.inviterPhone = this.query.inviterPhone.trim()
      if (this.query.inviteePhone) params.inviteePhone = this.query.inviteePhone.trim()
      if (this.query.status != null) params.status = this.query.status

      const res: any = await getInviteRewardLogPage(params)
      if (String(res.data.code) === '1' && res.data.data) {
        this.list = res.data.data.records || []
        this.total = res.data.data.total || 0
      } else {
        this.list = []
        this.total = 0
      }
    } catch (e) {
      this.list = []
      this.total = 0
    } finally {
      this.loading = false
    }
  }

  private tableIndex(index: number) {
    return (this.query.pageNum - 1) * this.query.pageSize + index + 1
  }

  private handleSearch() {
    this.query.pageNum = 1
    this.loadList()
  }

  private handleReset() {
    this.query.inviterPhone = ''
    this.query.inviteePhone = ''
    this.query.status = null
    this.query.pageNum = 1
    this.loadList()
  }

  private handleSizeChange(size: number) {
    this.query.pageSize = size
    this.loadList()
  }

  private handlePageChange(page: number) {
    this.query.pageNum = page
    this.loadList()
  }

  private formatDate(val: string) {
    if (!val) return '-'
    return val.replace('T', ' ').substring(0, 19)
  }
}
